<script>
  import Index from './winners/Index.svelte'
  import SearchInput from './winners/SearchInput.svelte'
  import SearchResults from './winners/SearchResults.svelte'
  import MobileFilterBar from './winners/MobileFilterBar.svelte'
  import NotFound from './NotFound.svelte'
  import Router, { link, push } from 'svelte-spa-router'
  import { years, searchQuery } from './winners/stores.js'

  let _searchQuery = ''
  let _years = []
  $: landingUrl = `/?year=${_years.length ? _years[0].slug : ''}`

  years.subscribe((value) => { _years = value })
  searchQuery.subscribe((value) => { _searchQuery = value })

  const routes = {
    '/:query?': Index,
    '/s/:query': SearchResults,
    '*': NotFound,
  }

  $: fetch(`/wp-json/wp/v2/winner_year?order=desc`)
    .then((r) => r.json())
    .then((data) => {
      if (data) {
        years.set(data)
      }
    })
</script>

<div class="pb-page">
  <div class="grid ya-grid-gap grid-cols-16 items-end">
    <div class="col-span-16 md:col-span-10 lg:col-span-12">
      <h1 class="h1">
        <a href={landingUrl} use:link on:click={() => {searchQuery.set('')}}>Competition Winners</a>
      </h1>
    </div>
    <div class="hidden md:block md:col-span-6 lg:col-span-4 lg:col-start-13 xl:col-span-3 xl:col-start-14">
      <SearchInput bind:query={_searchQuery} 
        on:input={() => { 
          push(`/s/${_searchQuery}`)
          searchQuery.set(_searchQuery)
        }}
        on:close={() => { 
          push(landingUrl)
          searchQuery.set('')
        }}
      />
    </div>
  </div>
  <MobileFilterBar />
  <Router {routes} />
</div>